import axios from "axios";

/**
 * Opens a new window with the HTML response of the given URL.
 * @param {String} url The URL to fetch.
 * @param {String} name The window name.
 * @param {String} features The window features.
 * @returns {Promise<Window>} A promise that resolves with the opened window.
 */
export function openHTMLWindow(url, name = "preview", features = "width=800,height=600") {
    const type = "text/html";
    return axios.get(url, { headers: { Accept: type } }).then((response) => {
        const html = response.data;
        return window.open(URL.createObjectURL(new Blob([html], { type })), name, features);
    });
}

const filter = (list, key, value) => list.filter((item) => item[key] === value);

/**
 * @description Data format of a single student options entry.
 * @typedef {{insured: boolean, employer_specific: boolean}} StudentOptionsData
 */

/**
 * Wrapper for the student options data.
 */
export class StudentOptions {
    /**
     * Constructs the StudentOptions wrapper.
     * @param {StudentOptionsData[]} data
     */
    constructor(data) {
        this.data = data || [];
    }

    /**
     * Filters the options by the given key and value.
     * @param {string} key
     * @param {*} value
     * @returns {StudentOptionsData[]}
     */
    filtered(key, value) {
        return filter(this.data, key, value);
    }

    /**
     * Returns the student options for the user with the specified UUID.
     * @param {string} uuid
     * @returns {StudentOptionsData|{}}
     */
    forUser(uuid) {
        const found = this.filtered("user", uuid);
        if (found.length === 0) {
            return {};
        }
        return found[0];
    }

    /**
     * Returns the student options as an object with the user UUID as key and the
     * options as value.
     * @returns {{[uuid: string]: StudentOptionsData}}
     */
    byUser() {
        return this.data.reduce((acc, item) => {
            acc[item.user] = item;
            return acc;
        }, {});
    }

    // /**
    //  * Returns the student options for users which are insured.
    //  * @returns {StudentOptionsData[]}
    //  */
    // insured() {
    //     return this.filtered("insurance", true);
    // }
    //
    // /**
    //  * Returns the student options for users with the employer_specific option.
    //  * @returns {StudentOptionsData[]}
    //  */
    // employerSpecific() {
    //     return this.filtered("employer_specific", true);
    // }
}
